module.exports = __webpack_public_path__ + "static/media/s_luge.e14f6f4e.mp3";